var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.catalogCompensation && _vm.catalogCompensation.hierarchyOwner && _vm.catalogCompensation.hierarchyOwner.parent)?_c('simple-text',{attrs:{"content":_vm.catalogCompensation.hierarchyOwner.parent.fullName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }